// extracted by mini-css-extract-plugin
export var compactFilters = "_f2-4";
export var detailImage = "_f2-1";
export var dropdownContainer = "_f2-2";
export var imageContainer = "_f2-0";
export var selectedCard = "_f2-3";